module.exports = __webpack_public_path__ + "img/neomo.1f7afea.webp";